module.exports = __webpack_public_path__ + "media/images/story/top/point_5-402a95c35977a1207bec86fbd1b1d8a3.svg";